import ObjectHeading from "@/components/ObjectHeading";
import { useMemo } from "react";
import { getUniversityEnrollmentCount } from "../../_utils";
import type { StudentProgramSummary } from "../../types";

interface UniversityHeadingProps {
  universityName: string;
  logoUrl?: string | null;
  activeStudentCount?: number;
  alumniStudentCount?: number;
  studentProgramSummary?: StudentProgramSummary[];
  className?: string;
}

export default function UniversityHeading({
  universityName,
  logoUrl,
  activeStudentCount = 0,
  alumniStudentCount = 0,
  studentProgramSummary,
  className = ""
}: UniversityHeadingProps) {
  const enrollmentCount = getUniversityEnrollmentCount({
    activeStudentCount,
    studentProgramSummary
  });
  const alumniCount = alumniStudentCount;

  const metaData = useMemo(
    () => [
      { text: enrollmentCount.toString(), label: "Enrollment" },
      { text: alumniCount.toString(), label: "Alumni" }
    ],
    [enrollmentCount, alumniCount]
  );

  return (
    <div className={className}>
      <ObjectHeading
        title={universityName}
        iconName="account_balance"
        imageUrl={logoUrl || undefined}
        metaData={metaData}
      />
    </div>
  );
}
